import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CalcResult } from '../../../utils/business';

export type LoansState = {
    initialFee: number;
    amount: number;
    percent: number;
    period: number;
    daysInMonth: number;
    daysInYear: number;
    annuity: CalcResult;
    differentiated: CalcResult;
    type?: number;
};

const initialState: LoansState = {
    initialFee: 0,
    amount: 0,
    percent: 0,
    period: 1,
    daysInMonth: 30,
    daysInYear: 360,
    annuity: {
        monthlyPayment: 0,
        totalAmount: 0,
        overPayment: 0,
    },
    differentiated: {
        monthlyPayment: 0,
        totalAmount: 0,
        overPayment: 0,
    },
    type: 0,
};

const loansSlice = createSlice({
    name: 'loans',
    initialState,
    reducers: {
        setCreditData(state, action: PayloadAction<LoansState>) {
            state.initialFee = Number(action.payload.initialFee);
            state.amount = Number(action.payload.amount);
            state.percent = Number(action.payload.percent);
            state.period = Number(action.payload.period);
            state.annuity = action.payload.annuity;
            state.differentiated = action.payload.differentiated;
            state.daysInMonth = Number(action.payload.daysInMonth);
            state.daysInYear = Number(action.payload.daysInYear);
        },
        resetCreditData(state) {
            state.initialFee = 0;
            state.amount = 0;
            state.percent = 0;
            state.period = 0;
            state.annuity = {
                monthlyPayment: 0,
                totalAmount: 0,
                overPayment: 0,
            };
            state.differentiated = {
                monthlyPayment: 0,
                totalAmount: 0,
                overPayment: 0,
            };
            state.daysInMonth = 30;
            state.daysInYear = 360;
        },
        setType: (state, action: PayloadAction<number>) => {
            state.type = action.payload;
        },
    },
});

export const { setCreditData, resetCreditData, setType } = loansSlice.actions;
export default loansSlice.reducer;
